// extracted by mini-css-extract-plugin
export default {"container":"LeaveDetails_container__48pSd","body":"LeaveDetails_body__3Li-A","headerRow":"LeaveDetails_headerRow__2C+bI","dateRow":"LeaveDetails_dateRow__eKHCH"};